export const ru = {
    'error-add': 'Ошибка! Не удалось добавить продукт',
    'success-add': 'Продукт успешно добавлен'
};
